import { NotificationHandler } from "./pwa/NotificationHandler.js";

export interface PwaConfig {
    uid: string;
    scope: string;
    serviceWorkerUrl: string;
    publicKey: string;
    subscribeUrl: string;
    unsubscribeUrl: string;
    notificationsEnabled: boolean;
}

export interface PwaMessage {
    action: string;
    data: any;
}

export class Pwa {

    public readonly config: PwaConfig;
    public readonly onMessage = e5.Signal.create<[PwaMessage]>();
    public readonly notification: NotificationHandler;

    private _installed: boolean | "auto" = "auto";

    constructor() {

        e5.console.log("[eventfive.wordpress-plugin]", "[Pwa]");

        var e = document.querySelector<HTMLElement>(`meta[name="e5-pwa-config"]`);
        if (!e) {
            console.warn(`Could not find meta[name="e5-pwa-config"]`);
            return;
        }

        e5.Plugins.pwa = this;

        var meta = document.querySelector(`meta[name="e5-pwa-config"]`) as HTMLElement;
        this.config = e5.object.merge({
        } as ToolsConfig, meta.dataset as any);
        this.config.notificationsEnabled = (this.config.notificationsEnabled as any) == "1";

        this.notification = new NotificationHandler(this.config);
        e5.Plugins.notification = this.notification;

        document.documentElement.setAttribute("data-e5-pwa-installed", this.installed ? "1" : "0");

        this.init();
    }

    public get supported(): boolean {
        return 'serviceWorker' in navigator;
    }

    public get installed(): boolean {

        if (!this.supported) {
            return false;
        }

        if (this._installed === "auto") {
            if (window.matchMedia === undefined) {
                return false;
            }

            var displayModes = [
                "fullscreen",
                "standalone",
                "minimal-ui"
            ];
            for (var displayMode of displayModes) {
                if (window.matchMedia(`(display-mode: ${displayMode})`).matches) {
                    return true;
                }
            }
            return false;
        }
        return this._installed;
    }

    private async init(): Promise<any> {

        if (!this.supported) {
            return;
        }

        window.addEventListener('appinstalled', (evt) => {
            this._installed = true;
            document.documentElement.setAttribute("data-e5-pwa-installed", "1");
            e5.console.log('PWA installed');
        });

        window.addEventListener('appuninstalled', (evt) => {
            e5.console.log('PWA uninstalled');
        });

        navigator.serviceWorker.addEventListener("message", (e) => {
            try {

                console.log("MESSAGE FROM SW", e.data);
                if (e.data
                    && e.data.eventfive) {
                    delete e.data.eventfive;
                    var msg: PwaMessage = e.data;
                    if (msg.action === "open-url") {
                        window.open(msg.data.url, "_self");
                    } else {

                    }
                    this.onMessage.dispatch(e.data);
                }
            } catch (error) {

            }
            console.log(e.data);
        });

        //Register the service worker for the offline cache.
        var reg = await navigator.serviceWorker.register(
            this.config.serviceWorkerUrl,
            {
                scope: this.config.scope,
                type: "classic",
                updateViaCache: "none"
            });

        // reg.addEventListener("updatefound", (e) => {
        //     this.log("Update found:", this.config.uid);
        // });


        // await navigator.serviceWorker.ready;
        // console.log(navigator.serviceWorker.controller);


        // First, do a one-off check if there's currently a
        // service worker in control.
        // if (navigator.serviceWorker.controller) {
        //     var u = new URL(navigator.serviceWorker.controller.scriptURL);
        //     var uid = u.searchParams.get("uid");
        //     if (uid) {
        //         // if (uid != this.config.uid) {
        //             // reg.update();
        //             // reg.unregister();
        //         // }
        //         this.log('This page is currently controlled by:', uid);
        //     }
        // }

        // Then, register a handler to detect when a new or
        // updated service worker takes control.
        // navigator.serviceWorker.addEventListener("controllerchange",
        //     () => {
        //         if (navigator.serviceWorker.controller) {
        //             var u = new URL(navigator.serviceWorker.controller.scriptURL);
        //             var uid = u.searchParams.get("uid");
        //             if (uid) {
        //                 this.log('This page is now controlled by:', uid);
        //             }
        //         }
        //     });

        // document.body.addEventListener("click", async () => {
        //     // this.push.subscribe();

        //     if (await this.push.isSubscribed()) {
        //         this.log(await this.push.unsubscribe());
        //     } else {
        //         this.log(await this.push.subscribe());
        //     }

        // });
    }
}

document.addEventListener("DOMContentLoaded", (e) => {
    new Pwa();
});